import CMS_LAYOUT from '@/views/cms/index.vue';
import { AppRouteRecordRaw } from '../types';

const CMS_ROUTER: AppRouteRecordRaw[] = [
  {
    path: 'dashboard', // The midline path complies with SEO specifications
    name: 'dashboard',
    component: () => import('@/views/dashboard/workplace/index.vue'),
    meta: {
      icon: 'icon-home',
      locale: '首页',
      requiresAuth: true,
      roles: ['*'],
    },
  },
  {
    path: 'account', // The midline path complies with SEO specifications
    name: 'account',
    component: CMS_LAYOUT,
    meta: {
      icon: 'icon-user-group',
      locale: '账号管理',
      requiresAuth: true,
      roles: ['admin'],
    },
  },
  {
    path: 'user', // The midline path complies with SEO specifications
    name: 'user',
    component: CMS_LAYOUT,
    meta: {
      icon: 'icon-user',
      locale: '用户管理',
      requiresAuth: true,
      roles: ['admin1'],
    },
  },
  {
    path: 'content', // The midline path complies with SEO specifications
    redirect: '/content/list',
    meta: {
      icon: 'icon-code-sandbox',
      locale: '内容管理',
      requiresAuth: true,
      roles: ['admin'],
    },
    children: [
      {
        path: 'product',
        name: 'product',
        component: CMS_LAYOUT,
        meta: {
          locale: '产品列表',
          requiresAuth: true,
          roles: ['admin'],
        },
      },

      {
        path: 'video',
        name: 'video',
        component: CMS_LAYOUT,
        meta: {
          locale: '视频列表',
          requiresAuth: true,
          roles: ['admin'],
        },
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: CMS_LAYOUT,
        meta: {
          locale: '产品分类',
          requiresAuth: true,
          roles: ['admin'],
        },
      },
      {
        path: 'banner', // The midline path complies with SEO specifications
        name: 'banner',
        component: CMS_LAYOUT,
        meta: {
          // icon: 'icon-settings',
          locale: 'banner管理',
          requiresAuth: true,
          roles: ['admin'],
        },
      },
      {
        path: 'appInfo', // The midline path complies with SEO specifications
        name: 'appInfo',
        component: CMS_LAYOUT,
        meta: {
          // icon: 'icon-settings',
          locale: '应用配置',
          requiresAuth: true,
          roles: ['admin'],
        },
      },
    ],
  },
  {
    path: '/reg/list', // The midline path complies with SEO specifications
    name: 'reg',
    component: CMS_LAYOUT,
    meta: {
      icon: 'icon-gift',
      locale: '注册有礼',
      requiresAuth: true,
      roles: ['admin'],
    },
  },
  {
    path: '/experiment/list', // The midline path complies with SEO specifications
    name: 'experiment',
    component: CMS_LAYOUT,
    meta: {
      icon: 'icon-experiment',
      locale: '实验申请管理',
      requiresAuth: true,
      roles: ['admin'],
    },
  },
  {
    path: '/aftersale/list', // The midline path complies with SEO specifications
    name: 'aftersale',
    component: CMS_LAYOUT,
    meta: {
      icon: 'icon-customer-service',
      locale: '售后管理',
      requiresAuth: true,
      roles: ['admin'],
    },
  },
  {
    path: '/parts/list', // The midline path complies with SEO specifications
    name: 'parts',
    component: CMS_LAYOUT,
    meta: {
      icon: 'icon-bug',
      locale: '配件采购管理',
      requiresAuth: true,
      roles: ['admin'],
    },
  },
  {
    path: '/equipment/list', // The midline path complies with SEO specifications
    name: 'equipment',
    component: CMS_LAYOUT,
    meta: {
      icon: 'icon-fire',
      locale: '新设备安装管理',
      requiresAuth: true,
      roles: ['admin'],
    },
  },
];
export default CMS_ROUTER;
